{ SESSION, StorageProxy } = require('common/lib/storage')
module.exports = new StorageProxy(SESSION)



// WEBPACK FOOTER //
// ./app/scripts/lib/session-storage.coffee